import { useCallback, useRef, useState } from 'react';

export function useSplitPane(initialPercent = 55) {
    const splitContainerRef = useRef<HTMLDivElement>(null);
    const [splitPercent, setSplitPercent] = useState(initialPercent);
    const [showPreview, setShowPreview] = useState(true);

    const handleDragStart = useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        const onMouseMove = (e: MouseEvent) => {
            if (!splitContainerRef.current) return;
            const rect = splitContainerRef.current.getBoundingClientRect();
            const percent = ((e.clientX - rect.left) / rect.width) * 100;
            setSplitPercent(Math.min(Math.max(percent, 25), 75));
        };
        const onMouseUp = () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }, []);

    return { splitContainerRef, splitPercent, showPreview, setShowPreview, handleDragStart };
}
